import { useEffect, useRef } from "react";
import Achievements_img from "../../assets/images/webp/Achievements_img.jpg";
import Achievements_img1 from "../../assets/images/webp/animatica_img1.jpg";
import Achievements_img2 from "../../assets/images/webp/animatica_img2.jpg";
import Achievements_img3 from "../../assets/images/webp/animatica_img3.jpg";
import Achievements_img4 from "../../assets/images/webp/animatica_img4.jpg";
import Achievements_img5 from "../../assets/images/webp/animatica_img5.jpg";
import Achievements_img6 from "../../assets/images/webp/animatica_img6.jpg";
import Achievements_img7 from "../../assets/images/webp/animatica_img7.jpg";
import Achievements_img8 from "../../assets/images/webp/animatica_img8.jpg";
import Achievements_img9 from "../../assets/images/webp/animatica_img9.jpg";
import Achievements_img10 from "../../assets/images/webp/animatica_img10.jpg";
import Achievements_img11 from "../../assets/images/webp/animatica_img11.jpg";
import Achievements_img12 from "../../assets/images/webp/animatica_img12.jpg";
import Achievements_img13 from "../../assets/images/webp/animatica_img13.jpg";
import slider_right_img from "../../assets/images/svg/slider_right_img.svg";
import slider_left_img from "../../assets/images/svg/slider_left_img.svg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { tiltHandlers } from "../hkianimatica/useTilt";
import "../../styles/animatica.css";
import "../../styles/skilling.css";

const SLIDES = [
  Achievements_img,
  Achievements_img1,
  Achievements_img2,
  Achievements_img3,
  Achievements_img4,
  Achievements_img5,
  Achievements_img6,
  Achievements_img7,
  Achievements_img8,
  Achievements_img9,
  Achievements_img10,
  Achievements_img11,
  Achievements_img12,
  Achievements_img13,
];

const MILESTONES = [
  {
    title: "Over 1,000 Students Placed",
    text: "Our students have achieved success, collaborating with leading celebrities in music videos and feature films. Through strong industry partnerships, HKI bridges talent with opportunity, offering real-world exposure and assured placements.",
  },
  {
    title: "Over 2,000 Students Trained in 2023-24",
    text: "We have made a significant impact in empowering the next generation of media professionals through our robust training programs.",
  },
  {
    title: "Skilling & Upskilling 10,200+ Artists",
    text: "In collaboration with MESC, we are on track to skill and upskill over 10,200 students in film production and animation this year, directly contributing to India's creative economy.",
  },
  {
    title: "Expansion with 20 AVGC-XR CoEs",
    text: "With 20 planned Centers of Excellence (CoEs) across North India, we are taking a giant leap toward empowering youth with futuristic skills for the digital age.",
  },
  {
    title: "National Affiliations",
    text: "Proudly recognized under Startup India, Skill India, and affiliated with NSDC, MESC, UPSDM, TCIL, and ICASA.",
  },
];

const SkillingAchievements = () => {
  const sliderRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          element.classList.add("an-visible");
          observer.disconnect();
        }
      },
      { threshold: 0.15 },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <div ref={sectionRef} className="an-section skilling-home-section py-5">
      <div className="an-glow an-glow-right" />
      <div className="container pb-5 py-md-4 py-0 rounded-2 p-4 position-relative">
        <span className="an-reveal an-reveal-d1 an-eyebrow justify-content-center w-100">
          Milestones
        </span>
        <h4 className="an-reveal an-reveal-d2 fs_44 fw-bold ff_s an-title-gradient d-block mb-0 text-center">
          We Breed Creative, We Bleed Creative
        </h4>
        <p className="an-reveal an-reveal-d3 fs_24 fw-semibold mt-2 mt-md-0 ff_n mb-0 text-gray-300 text-center">
          Transforming Media Talents
        </p>
        <div className="row align-items-center justify-content-between mt-md-5 mt-3">
          <div className="col-md-6 mt-4">
            <ul className="an-num-list ps-md-4 ps-2">
              {MILESTONES.map((item, index) => (
                <li
                  key={item.title}
                  className={`an-reveal an-reveal-d${Math.min(index + 1, 5)} an-num-item`}
                >
                  <span className="an-num-badge">{index + 1}</span>
                  <p className="fs_16 ff_n mb-0">
                    <strong className="darkredtext">{item.title}:&nbsp;</strong>
                    <span className="text-gray-300 fw-normal">{item.text}</span>
                  </p>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-md-6 mt-4 ps-md-5">
            <div
              className="animatica_slider an-tilt an-reveal an-reveal-d3 an-glass p-3"
              {...tiltHandlers}
            >
              <Slider ref={sliderRef} {...settings}>
                {SLIDES.map((src, index) => (
                  <div key={index}>
                    <img loading="lazy" decoding="async" className="w-100" src={src} alt={`Achievement ${index + 1}`} />
                  </div>
                ))}
              </Slider>
            </div>
            <div className="d-flex position-relative z-3 justify-content-end gap-2 mt-3">
              <img
                loading="lazy"
                decoding="async"
                className="cursor-pointer"
                src={slider_left_img}
                alt="Previous slide"
                onClick={() => sliderRef.current.slickPrev()}
              />
              <img
                loading="lazy"
                decoding="async"
                className="cursor-pointer"
                src={slider_right_img}
                alt="Next slide"
                onClick={() => sliderRef.current.slickNext()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkillingAchievements;
